import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import NeaElectricity from './Operator/NeaElectricity';
import DishHome from './Operator/DishHome';
import Slrec from "./Operator/Slrec";
import MaxTV from "./Operator/MaxTV";
import SimTV from "./Operator/SimTV";
import NetTV from "./Operator/NetTV";
import PrabhuTV from "./Operator/PrabhuTV";
import Khanepani from "./Operator/Khanepani";
import KUKLKhanepani from "./Operator/KUKLKhanepani";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function UtilityBillDthPay() {
  const [operatorCode, setOperatorCode] = useState(false);
  const [providers, setProviders] = useState(false);
  const getOperatorCode = (e) => {
    setOperatorCode(e.target.value);
  };
  const getData = async () => {
    try {
      const response = await axios.get('/admin/get/all/providers/NEPALESE', { params: { category_name: "Utility Bills DTH Pay" } });
      const { status, data } = response.data;
      if (status) {
        setProviders(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <div className="row">
        <div class="col-lg-12 col-md-12">
          <label>Operator</label>
          <select class="form-control" name="OperatorCode" onChange={getOperatorCode}>
            <option value="">--Select--</option>
            {
              (providers && providers.length > 0) && providers.map((provider) => (
                provider.status == "Active" && (
                  <option value={provider._id}>{provider.provider_name}</option>
                )
              ))
            }
          </select>
        </div>
        {
          operatorCode && (
            <>
              {
                operatorCode == "67b47a96c5db601a784df51c" ? (
                  <>
                    <NeaElectricity operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67b470fac5db601a784df512" ? (
                  <>
                    <DishHome operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67c695876535dce1456e635c" ? (
                  <>
                    <Slrec operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67b8691dd8ec45da06ff6a50" ? (
                  <>
                    <MaxTV operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67fe317a97f3f263fdcee3ae" ? (
                  <>
                    <SimTV operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ff9490e77e42c9398cfae6" ? (
                  <>
                    <NetTV operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ff9891e77e42c9398cfae7" ? (
                  <>
                    <PrabhuTV operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ffabe6e77e42c9398cfae9" ? (
                  <>
                    <Khanepani operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "6800aa94f321bcafc23080c2" ? (
                  <>
                    <KUKLKhanepani operatorCode={operatorCode} />
                  </>
                ) : ""
              }
            </>
          )
        }
      </div>
    </>
  );
}

export default UtilityBillDthPay;
